import React from 'react';
import RenderItem from './RenderItem'
import {
    MDBBtn,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
    MDBInput,
} from 'mdb-react-ui-kit';
import { connect } from 'react-redux';
import Pagination from '../Pagination';
import { baseURL } from '../../api/baseURL';
import axios from 'axios';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import Loader from '../../Loader';
import Modal from '../../Modal';
import { isMainAdmin } from '../../utils/isMainAdmin';
import AdminShell from '../layout/AdminShell';
import { countPillStyle, thStyle } from '../layout/listUi';

type State = {
    requested: boolean,
    err: boolean,
    discountCodeList: any,
    photoOpen: boolean,
    modalOpen: boolean,
    basicModal: boolean,
    currentPage: number,
    voucherCode: string,
    startDate: any,
    endDate: any,
    discountAmt: number,
    maxUsageCount: number,
    minHoursToApply: number,
    // Phase 2 §9: service-wise promo codes — empty = applies to all services.
    availableServices: { key: string, name: string }[],
    applicableServices: string[],
};

class DiscountList extends React.Component<{ history: any, token?: string, role?: string }> {
    state: State = {
        requested: false,
        err: false,
        discountCodeList: null,
        photoOpen: false,
        modalOpen: false,
        currentPage: 1,
        basicModal: false,
        voucherCode: "",
        startDate: "",
        endDate: "",
        discountAmt: 100,
        maxUsageCount: 1,
        minHoursToApply: 1,
        availableServices: [],
        applicableServices: [],
    }

    fetchAvailableServices = () => {
        axios.get(`${baseURL}/services`, { headers: { Authorization: `Bearer ${this.props.token}` } })
            .then((response: any) => {
                this.setState({ availableServices: (response?.data?.services || []).map((s: any) => ({ key: s.key, name: s.name })) });
            })
            .catch(() => {});
    }

    toggleApplicableService = (key: string) => {
        this.setState((prev: State) => ({
            applicableServices: prev.applicableServices.includes(key)
                ? prev.applicableServices.filter((k) => k !== key)
                : [...prev.applicableServices, key],
        }));
    }

    componentDidMount(): void {
        if (!this.props.token) {
            window.location.pathname = "/";
        }
        else {
            this.getDiscountCodeList(parseInt(window.location.search.split("?page=")[1]) ? parseInt(window.location.search.split("?page=")[1]) : 1);
            this.fetchAvailableServices();
        }
    }

    getDiscountCodeList = (pageNumber: number) => {
        if (!this.state.requested) {
            this.setState({ err: false, requested: true });
            axios.get(`${baseURL}/vouchers?page=${pageNumber}&limit=10`,
                {
                    headers: { Authorization: `Bearer ${this.props.token}` }
                })
                .then((response: any) => {
                  //console.log(response);
                    if (response?.data?.message === "success") {
                        this.setState({ discountCodeList: response?.data, requested: false, err: false, currentPage: pageNumber });
                    }
                    else {
                        this.setState({ err: true, requested: false });
                    }
                })
                .catch((error: any) => {
                  //console.log(error);
                    this.setState({ err: true, requested: false });
                })
        }
    }

    removeVoucher = (voucherId: string) => {
        if (!this.state.requested) {
            this.setState({ err: false, requested: true });
            axios.post(`${baseURL}/remove-voucher`,
                {
                    voucherId
                },
                {
                    headers: { Authorization: `Bearer ${this.props.token}` }
                })
                .then((response: any) => {
                  //console.log(response);
                    if (response?.data?.message === "success") {
                        let temp = this.state.discountCodeList;
                        let newVouchersList = temp.vouchers.filter((item: any) => {
                            if (item?._id !== voucherId) {
                                return item;
                            }
                        });
                        temp.vouchers = newVouchersList;
                        this.setState({ discountCodeList: temp, requested: false, err: false });
                    }
                    else {
                        this.setState({ err: true, requested: false });
                    }
                })
                .catch((error: any) => {
                  //console.log(error);
                    this.setState({ err: true, requested: false });
                })
        }
    }

    addVoucher = () => {
        if (!this.state.requested) {
            this.setState({ err: false, requested: true });
            axios.post(`${baseURL}/add-voucher`,
                {
                    voucherCode: this.normalizeVoucherCode(this.state.voucherCode),
                    startDate: this.state.startDate?._d?.toISOString(),
                    endDate: this.state.endDate?._d?.toISOString(),
                    discountAmt: this.state.discountAmt,
                    maxUsageCount: this.state.maxUsageCount,
                    minHoursToApply: this.state.minHoursToApply,
                    applicableServices: this.state.applicableServices,
                },
                {
                    headers: { Authorization: `Bearer ${this.props.token}` }
                })
                .then((response: any) => {
                  //console.log(response);
                    if (response?.data?.message === "success") {
                        window.location.reload();
                    }
                    else {
                        this.setState({ err: true, requested: false });
                    }
                })
                .catch((error: any) => {
                  //console.log(error);
                    this.setState({ err: true, requested: false });
                })
        }
    }

    toggleOpen = () => {
        if (this.state.modalOpen) {
            this.setState({ modalOpen: false });
        }
        else if (!this.state.modalOpen) {
            this.setState({ modalOpen: true });
        }
    }

    setBasicModal = () => {
        if (this.state.basicModal) {
            this.setState({ basicModal: false, voucherCode: '', applicableServices: [] });
        }
        else if (!this.state.basicModal) {
            this.setState({ basicModal: true, voucherCode: '', applicableServices: [] });
        }
    }

    onPageChange = (pageNumber: number) => {
        this.getDiscountCodeList(pageNumber);
    }

    toggleModal = () => {
        if (this.state.err) {
            this.setState({ err: false });
        }
    }

    normalizeVoucherCode = (raw: string) => String(raw || '').replace(/\s/g, '').trim().toUpperCase();

    handleVoucherCodeChange = (e: any) => {
        const value = typeof e === 'string' ? e : (e?.target?.value ?? '');
        this.setState({ voucherCode: this.normalizeVoucherCode(value) });
    };

    render() {
      //console.log(this.state)
        return (
            <AdminShell activePage="discounts" title="Discounts" subtitle="Promo codes and usage limits">
                <Modal open={this.state.err} hideSec primaryText="Okay" title='Update' onConfirm={this.toggleModal} toggleOpen={this.toggleModal} content={<h6>Something went wrong, please try again later</h6>} />
                {this.state.requested ? <Loader /> : null}
                                    <div className="card">
                                        <div className="card-body">
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                <h4 className="card-title">
                                                    Discounts
                                                    {this.state.discountCodeList?.total ? <span style={countPillStyle}>{this.state.discountCodeList.total}</span> : null}
                                                </h4>
                                                {isMainAdmin(this.props.role) ? <MDBBtn onClick={() => this.setBasicModal()}>Add New Code</MDBBtn> : null}
                                            </div>
                                            <div className="table-responsive">
                                                {(this.state.discountCodeList?.vouchers?.length) ? <table className="table">
                                                    <thead>
                                                        <tr>
                                                            <th style={thStyle}> Promo Code </th>
                                                            <th style={thStyle}> Start Date </th>
                                                            <th style={thStyle}> End Date </th>
                                                            <th style={thStyle}> Amount </th>
                                                            <th style={thStyle}> Max No. of Usage </th>
                                                            <th style={thStyle}> Left Usage </th>
                                                            <th style={thStyle}> Minimum Hours Required</th>
                                                            <th style={thStyle}> Applies To </th>
                                                            <th style={thStyle}> Action </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.discountCodeList?.vouchers?.length ?
                                                            this.state.discountCodeList?.vouchers.map((item: any) => {
                                                                return <RenderItem key={item?._id} removeVoucher={this.removeVoucher} item={item} requested={this.state.requested} err={this.state.err} isMainAdmin={isMainAdmin(this.props.role)} />;
                                                            })
                                                            : null}
                                                    </tbody>
                                                </table> : <div style={{ display: 'flex', justifyContent: 'center', padding: 15, paddingTop: 30 }}>
                                                    <div className="badge badge-outline-secondary" style={{ fontSize: 16 }}>No Data</div>
                                                </div>}
                                            </div>
                                        </div>
                                    </div>
                            {(this.state.discountCodeList?.total / 10) > 1 ? <Pagination onPageChange={this.onPageChange} currentPage={this.state.currentPage} totalPages={(this.state.discountCodeList?.total / 10) < 1 ? (this.state.discountCodeList?.total / 10) : Math.ceil(this.state.discountCodeList?.total / 10)} maxVisible={5} /> : null}
                <>
                    <MDBModal open={!this.state.requested && !this.state.err && this.state.basicModal} onClose={() => { this.setBasicModal() }} tabIndex='-1'>
                        <MDBModalDialog>
                            <MDBModalContent>
                                <MDBModalHeader>
                                    <MDBModalTitle>Promo Code</MDBModalTitle>
                                    <MDBBtn floating style={{ display: 'flex', padding: 5, height: 30, width: 30 }} onClick={() => { this.setBasicModal() }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30" height="30" viewBox="0 0 30 30">
                                            <path d="M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z" stroke="#FFF" fill="#FFF"></path>
                                        </svg>
                                    </MDBBtn>
                                </MDBModalHeader>
                                <MDBModalBody style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
                                    <MDBInput contrast label="Promo Code" id="code" type="text" maxLength={50} value={this.state.voucherCode} onChange={this.handleVoucherCodeChange} style={{ textTransform: 'uppercase' }} />
                                    <MDBInput contrast label="Discount Amount" id="amount" type="number" defaultValue={this.state.discountAmt} onChange={(e) => { this.setState({ discountAmt: parseInt(e.target.value) ? parseInt(e.target.value) : 100 }) }} />
                                    <MDBInput contrast label="Max No. of Usage" id="amount" type="number" defaultValue={this.state.maxUsageCount} onChange={(e) => { this.setState({ maxUsageCount: parseInt(e.target.value) ? parseInt(e.target.value) : 1 }) }} />
                                    <MDBInput contrast label="Min. Hours to Apply" id="amount" type="number" defaultValue={this.state.minHoursToApply} onChange={(e) => { this.setState({ minHoursToApply: parseInt(e.target.value) ? parseInt(e.target.value) : 1 }) }} />
                                    <div>
                                        <label style={{ color: '#999', fontSize: 12, marginBottom: 5, display: 'block' }}>
                                            Applies to (leave all unchecked for every service)
                                        </label>
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
                                            {this.state.availableServices.map((svc) => (
                                                <label key={svc.key} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, cursor: 'pointer' }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={this.state.applicableServices.includes(svc.key)}
                                                        onChange={() => this.toggleApplicableService(svc.key)}
                                                    />
                                                    {svc.name}
                                                </label>
                                            ))}
                                        </div>
                                    </div>
                                    <Datetime
                                        renderInput={(props, openCalendar, closeCalendar) => (
                                            <MDBInput
                                                contrast
                                                label="Start Date and Time"
                                                {...props}
                                                style={{ background: 'transparent' }}
                                                readOnly
                                            />
                                        )}
                                        value={this.state.startDate}
                                        onChange={(e) => { this.setState({ startDate: e }) }}
                                    />
                                    <Datetime
                                        renderInput={(props, openCalendar, closeCalendar) => (
                                            <MDBInput
                                                contrast
                                                label="End Date and Time"
                                                {...props}
                                                style={{ background: 'transparent' }}
                                                disabled={!this.state.startDate}
                                                readOnly
                                            />
                                        )}
                                        isValidDate={(currentDate) => currentDate.isAfter(this.state.startDate)}
                                        value={this.state.endDate}
                                        onChange={(e) => { this.setState({ endDate: e }) }}
                                    />
                                </MDBModalBody>
                                <MDBModalFooter>
                                    <MDBBtn color='secondary' onClick={() => { this.setBasicModal() }}>
                                        Close
                                    </MDBBtn>
                                    <MDBBtn
                                        onClick={() => {
                                            if (this.state.voucherCode && this.state.startDate?._d && this.state.endDate?._d && this.state.discountAmt) {
                                                this.addVoucher();
                                            }
                                            else {
                                                alert("Please fill all the fields");
                                            }
                                        }}>
                                        Submit
                                    </MDBBtn>
                                </MDBModalFooter>
                            </MDBModalContent>
                        </MDBModalDialog>
                    </MDBModal>
                </>
            </AdminShell>
        );
    }
}

const mapDispatchToProps = (dispatch: Function) => {
    return {
        dispatch
    }
}

const mapStateToProps = (state: any, ownProps: any) => {
    return {
        token: state.auth.token,
        role: state.auth.role,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscountList);
